import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Logout from '../components/Logout/Logout'

import jwtDecode from 'jwt-decode'

export function requireAuth(ComposedComponent, props) {
  class Authentication extends Component {
        state = {
          redirect: false,
          isTokenExpired: false,
        }

        // should do it in componentDidMount cause it's going to be deprecated
        componentWillMount() {
          if (!this.props.auth.isAuthenticated) {
            this.setState({ redirect: true })
          } else {
            const token = localStorage.getItem('reggora_auth_token')
            if (typeof token !== 'string') {
              this.setState({
                isTokenExpired: true,
              })
            } else {
              const tokenExpirationDate = Date.parse(jwtDecode(token).exp)
              const currentTime = new Date()
              this.setState({ isTokenExpired: currentTime > tokenExpirationDate })
            }
          }
        }

        componentWillUpdate(nextProps) {
          if (!nextProps.auth.isAuthenticated) {
            this.setState({ redirect: true })
          }
        }

        render() {
          const { redirect, isTokenExpired } = this.state
          if (redirect) {
            return (
                    <Redirect to='/login' />
            )
          } else if (isTokenExpired) {
            return (
                    <Logout />
            )
          } else {
            return (
                  <ComposedComponent {...this.props} {...props} />
            )
          }
        }
  }
  function mapStateToProps(state) {
    return {
      userRole: state.currentUser.currentUser.role,
      auth: state.auth,
    }
  }
  return connect(mapStateToProps)(Authentication)
}
